// extracted by mini-css-extract-plugin
var _1 = "DocFlowEditSequenceModalContent-modulecontentWrapper__gGVEi Content-modulecontentWrapper__p1AMw";
export { _1 as "contentWrapper" }
